import { defaultHoverTransition } from '@shared/utils';
import cx from 'classnames';

import { IconType } from 'utils/types';

interface ChatPrivacyOptionProps {
  value: string;
  checked: boolean;
  onClick: () => void;
  title: string;
  description: string;
  icon: IconType;
}

const ChatPrivacyOption = ({ checked, onClick, title, description, icon: Icon }: ChatPrivacyOptionProps) => (
  <div
    className={cx(
      'flex flex-1 flex-col items-start p-4 rounded-xl border cursor-pointer',
      defaultHoverTransition,
      checked
        ? 'bg-primaryComp-10 border-primary-50 hover:bg-primaryComp-20'
        : 'bg-gray-10 border-gray-30 hover:bg-white hover:border-gray-40'
    )}
    onClick={onClick}
  >
    <div className="flex gap-4 items-start justify-between w-full">
      <div className="flex flex-1 flex-col gap-1 items-start min-w-0">
        <div className="flex gap-2 items-center w-full">
          <Icon className="h-5 w-5 stroke-current stroke-1.5" />
          <span className="font-medium text-sm text-grayscale-black">{title}</span>
        </div>
        <p className="text-xs leading-4 text-grayscale-gray60 w-full">{description}</p>
      </div>
      {checked ? (
        <div className="flex items-center justify-center p-1.5 rounded-full border border-primaryComp-50 bg-white">
          <div className="h-2 w-2 rounded-full bg-primaryComp-50" />
        </div>
      ) : (
        <div className="h-5 w-5 rounded-full border border-grayscale-gray40 bg-white" />
      )}
    </div>
  </div>
);

export default ChatPrivacyOption;
